import { MutableRefObject } from 'react';
import { LoaderProps } from '@wix/design-system';

export interface InfiniteScrollLoaderBaseProps extends Partial<LoaderProps> {
  targetRef: MutableRefObject<HTMLElement | null | undefined>;
}
